var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "jade-radio-group" }, [
    _c(
      "span",
      { class: _vm.computedClassLabel },
      [
        _c(
          "JadeText",
          {
            attrs: {
              variant: "text-medium",
              weight: "medium",
              color: "current-color",
            },
          },
          [_vm._v(" " + _vm._s(_vm.label) + " ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { class: _vm.computedClassCluster },
      _vm._l(_vm.items, function (item) {
        return _c("JadeRadioButton", {
          key: item.label,
          attrs: {
            label: item.label,
            id: item.id,
            name: item.name,
            disabled: _vm.disabled,
            value: item.value,
          },
          on: { onChange: ($event) => _vm.$emit("update:value", $event) },
        })
      }),
      1
    ),
    _c(
      "span",
      { class: _vm.computedClassSupportText },
      [
        _vm.error
          ? _c("JadeIcon", {
              attrs: { use: "circle-alert", size: "small", color: "negative" },
            })
          : _vm._e(),
        _c(
          "JadeText",
          {
            attrs: {
              variant: "text-small",
              weight: "regular",
              color: "current-color",
            },
          },
          [_vm._v(" " + _vm._s(_vm.supportText) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }